"use client";
import { styled } from "@mui/material/styles";
import { memo, ReactNode } from "react";
import { Layout1ConfigDefaultsType } from "@/components/theme-layouts/layout1/Layout1Config";
import useFuseLayoutSettings from "@fuse/core/FuseLayout/useFuseLayoutSettings";
import FooterLayout1 from "./components/FooterLayout1";
import LeftSideLayout1 from "./components/LeftSideLayout1";
import NavbarWrapperLayout1 from "./components/NavbarWrapperLayout1";
import RightSideLayout1 from "./components/RightSideLayout1";
import ToolbarLayout1 from "./components/ToolbarLayout1";
import FuseSuspense from "@fuse/core/FuseSuspense";
import PersistentOutlet from "../components/PersistentOutlet";

const Root = styled("div")(({ config }: { config: Layout1ConfigDefaultsType }) => ({
	...(config.mode === "fullwidth" && {
		"& .container": {
			maxWidth: "100%!important",
			width: "100%!important",
		},
	}),
}));

type Layout1Props = {
	children?: ReactNode;
};

/**
 * The layout 1.
 */
function Layout1(props: Readonly<Layout1Props>) {
	const { children } = props;
	const settings = useFuseLayoutSettings();
	const config = settings.config as Layout1ConfigDefaultsType;

	return (
		<Root id="fuse-layout" config={config} className="flex w-full flex-auto">
			{config.leftSidePanel.display && <LeftSideLayout1 />}

			<div className="flex min-w-0 flex-auto">
				{config.navbar.display && config.navbar.position === "left" && <NavbarWrapperLayout1 />}

				<main id="fuse-main" className="relative z-10 flex min-h-svh min-w-0 flex-auto flex-col">
					{config.toolbar.display && (
						<ToolbarLayout1 className={config.toolbar.style === "fixed" ? "sticky top-0" : ""} />
					)}

					<div className="relative z-10 flex min-h-0 flex-auto flex-col">
						<FuseSuspense>
							<PersistentOutlet />
						</FuseSuspense>
						{children}
					</div>

					{config.footer.display && <FooterLayout1 />}
				</main>

				{config.navbar.display && config.navbar.position === "right" && <NavbarWrapperLayout1 />}
			</div>

			{config.rightSidePanel.display && <RightSideLayout1 />}
		</Root>
	);
}

export default memo(Layout1);
